<template>
    <div>
        <calendar-navigation
            :meta="meta"
            view="day"
            :show-view-switch="showViewSwitch"
            @set-view="setView"
            @set-date="setDate"
        ></calendar-navigation>

        <layout-box>
            <div class="flex flex-auto overflow-hidden bg-white dark:bg-zinc-800 isolate h-[70vh] min-h-[680px]">
                <div ref="container" class="flex flex-col flex-auto overflow-auto">
                    <div
                        ref="containerNav"
                        class="sticky top-0 z-10 grid flex-none grid-cols-7 text-xs text-gray-500 bg-white shadow dark:bg-zinc-800 ring-1 ring-black/5 md:hidden"
                    >
                        <button
                            v-for="day in days"
                            :key="day.date"
                            type="button"
                            class="flex flex-col items-center pt-3 pb-1.5"
                            @click="setDate(day)"
                        >
                            <span>{{ day.dayLetter }}</span>
                            <span
                                class="flex items-center justify-center w-8 h-8 mt-3 text-base font-semibold rounded-full"
                                :class="[
                                    day.isToday && !day.isSelected
                                        ? 'text-brand-600 dark:text-brand-600'
                                        : 'text-gray-900 dark:text-zinc-50',
                                    day.isSelected ? 'bg-gray-100 dark:bg-zinc-900' : '',
                                ]"
                                >{{ day.day }}</span
                            >
                        </button>
                    </div>
                    <div class="flex flex-auto w-full">
                        <div class="flex-none bg-white dark:bg-zinc-800 w-14 ring-1 ring-gray-100 dark:ring-zinc-700" />
                        <div class="grid flex-auto grid-cols-1 grid-rows-1">
                            <!-- Horizontal lines -->
                            <div
                                class="grid col-start-1 col-end-2 row-start-1 divide-y divide-gray-100 dark:divide-zinc-700"
                                style="grid-template-rows: repeat(48, minmax(3.5rem, 1fr))"
                            >
                                <div ref="containerOffset" class="row-end-1 h-7"></div>
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        0:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        1:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        2:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        3:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        4:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        5:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        6:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        7:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        8:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        9:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        10:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        11:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        12:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        13:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        14:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        15:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        16:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        17:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        18:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        19:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        20:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        21:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        22:00
                                    </div>
                                </div>
                                <div />
                                <div>
                                    <div
                                        class="sticky left-0 -mt-2.5 -ml-14 w-14 pr-2 text-right text-xs leading-5 text-gray-400"
                                    >
                                        23:00
                                    </div>
                                </div>
                                <div />
                            </div>

                            <!-- Events -->
                            <ol
                                class="grid col-start-1 col-end-2 row-start-1"
                                :class="[`grid-cols-${events.length}`]"
                                style="grid-template-rows: 1.75rem repeat(288, minmax(0, 1fr)) auto"
                            >
                                <template v-for="(day, dayIndex) in selectedDays" :key="day.date">
                                    <li
                                        v-for="event in day.events"
                                        :key="event.id"
                                        class="relative flex mt-px"
                                        :class="[`sm:col-start-${dayIndex + 1}`]"
                                        :style="{
                                            gridRow: `
                                            ${12 * event.startHour + (2 * event.startMinute) / 30 + 2} / ${
                                                12 * event.endHour + (2 * event.endMinute) / 30 + 2
                                            }`,
                                        }"
                                    >
                                        <inertia-link
                                            :href="event.url"
                                            class="absolute flex flex-col p-2 overflow-y-auto text-xs leading-5 border rounded-lg group inset-1"
                                            :class="[
                                                `bg-${event.color}-50 hover:bg-${event.color}-100 border-${event.color}-400 dark:bg-${event.color}-700/30 dark:border-${event.color}-700 dark:hover:bg-${event.color}-900`,
                                            ]"
                                        >
                                            <p class="order-1 font-semibold" :class="[`text-${event.color}-700`]">
                                                {{ event.name }}
                                            </p>
                                            <p :class="[`text-${event.color}-500 group-hover:text-${event.color}-700`]">
                                                <time :datetime="event.blocking_calendar_from">{{ event.time }}</time>
                                            </p>
                                            <!-- eslint-disable -->
                                            <div class="order-2" v-html="event.instructor.avatar"></div>
                                            <!-- eslint-enable -->
                                        </inertia-link>
                                    </li>
                                </template>
                            </ol>
                        </div>
                    </div>
                </div>
                <div
                    class="flex-none hidden w-1/2 max-w-md px-8 py-10 border-l border-gray-100 dark:border-zinc-700 md:block"
                >
                    <div class="flex items-center text-center text-gray-900 dark:text-zinc-50">
                        <button
                            type="button"
                            class="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                            @click="previous"
                        >
                            <span class="sr-only">Previous month</span>
                            <icon icon="hero/outline/chevron-left" class="w-5 h-5" aria-hidden="true"></icon>
                        </button>
                        <div class="flex-auto font-semibold">{{ meta.monthTitle }}</div>
                        <button
                            type="button"
                            class="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-400 hover:text-gray-500"
                            @click="next"
                        >
                            <span class="sr-only">Next month</span>
                            <icon icon="hero/outline/chevron-right" class="w-5 h-5" aria-hidden="true"></icon>
                        </button>
                    </div>
                    <div class="grid grid-cols-7 mt-6 text-xs leading-6 text-center text-gray-500">
                        <div>P</div>
                        <div>Ú</div>
                        <div>S</div>
                        <div>Č</div>
                        <div>P</div>
                        <div>S</div>
                        <div>N</div>
                    </div>
                    <div
                        class="grid grid-cols-7 gap-px mt-2 text-sm bg-gray-200 rounded-lg shadow isolate ring-1 ring-gray-200 dark:ring-zinc-900 dark:bg-zinc-900"
                    >
                        <button
                            v-for="(day, dayIdx) in days"
                            :key="day.date"
                            type="button"
                            :class="[
                                'py-1.5 hover:bg-gray-100 focus:z-10',
                                day.isCurrentMonth ? 'bg-white dark:bg-zinc-800' : 'bg-gray-50 dark:bg-zinc-700',
                                (day.isSelected || day.isToday) && 'font-semibold',
                                day.isSelected && 'text-white',
                                !day.isSelected &&
                                    day.isCurrentMonth &&
                                    !day.isToday &&
                                    'text-gray-900 dark:text-zinc-50',
                                !day.isSelected && !day.isCurrentMonth && !day.isToday && 'text-gray-400',
                                day.isToday && !day.isSelected && 'text-brand-600',
                                dayIdx === 0 && 'rounded-tl-lg',
                                dayIdx === 6 && 'rounded-tr-lg',
                                dayIdx === days.length - 7 && 'rounded-bl-lg',
                                dayIdx === days.length - 1 && 'rounded-br-lg',
                            ]"
                            @click="setDate(day)"
                        >
                            <time
                                :datetime="day.date"
                                :class="[
                                    'mx-auto flex h-7 w-7 items-center justify-center rounded-full',
                                    day.isSelected && day.isToday && 'bg-brand-600',
                                    day.isSelected && !day.isToday && 'bg-gray-900',
                                ]"
                                >{{ day.date.split('-').pop().replace(/^0/, '') }}</time
                            >
                        </button>
                    </div>
                </div>
            </div>
        </layout-box>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import CalendarNavigation from '@src/Reservations/Pages/Calendar/Partials/Navigation.vue';

const props = defineProps({
    date: {
        type: Object,
        default: () => ({
            day: null,
            month: null,
            year: null,
        }),
    },
    showViewSwitch: {
        type: Boolean,
        default: true,
    },
});

const showViewSwitch = ref(props.showViewSwitch);

const emit = defineEmits(['setView', 'setDate']);

const setView = (view: string) => emit('setView', view);

const container = ref(null);
const containerNav = ref(null);
const containerOffset = ref(null);

const days = ref([]);
const meta = ref([]);

const getData = ({ day, month, year } = { day: null, month: null, year: null }) => {
    axios
        .get(route('reservations.calendar.api.day'), {
            params: {
                day,
                month,
                year,
            },
        })
        .then(({ data }) => {
            days.value = data.days;
            meta.value = data.meta;
        });
};

onMounted(() => {
    // Set the container scroll position based on the current time.
    const currentMinute = new Date().getHours() * 60;
    container.value.scrollTop =
        ((container.value.scrollHeight - containerNav.value.offsetHeight - containerOffset.value.offsetHeight) *
            currentMinute) /
        1440;

    getData(props.date);
});

const setDate = ({ day, month, year }) => {
    getData({ day, month, year });
    emit('setDate', { day, month, year });
};

const previous = () => {
    setDate(meta.value.previousData);
};

const next = () => {
    setDate(meta.value.nextData);
};

const selectedDays = computed(() => {
    return days.value.filter((day) => day.isSelected);
});

const events = computed(() => {
    return selectedDays.value.reduce((acc, day) => {
        return [...acc, ...day.events];
    }, []);
});
</script>
